export default interface IFirebaseJackpotBetsWinNotificationData extends IFirebaseJackpotBetsPlayerNotificationBaseData {
      winAmount: number;
      currencyCode: number;
      jackpotId: number;
      gameCycleId: number;
      participationFee: number;
      parentGameBetAmount: number;
}

interface IFirebaseJackpotBetsPlayerNotificationBaseData {
      cid: number;
      timestamp: string;
      gameTypeId: number;
}

export interface JackpotBetsErrorNotificationFirebaseMessageData {
      data: IFirebaseJackpotBetsErrorNotificationData;
      id: string;
      type: string;
}

export interface JackpotBetsWinNotificationFirebaseMessageData {
      data: IFirebaseJackpotBetsWinNotificationData;
      id: string;
      type: string;
}


export interface IFirebaseJackpotBetsErrorNotificationData extends IFirebaseJackpotBetsPlayerNotificationBaseData {
      serverId: number;
      parentGameTypeId: number;
      regulationTypeId: number;
      gameId: number;
      brandId: number;
      playerSessionId: number;
      subBrandId: number;
      productPackage: number;
      gameBetAmount: number;
      valueOfFailedBet: number;
      failedReasonId: JackpotBetRejectionReason;
      failedReasonDescription: string;
}

export enum JackpotBetRejectionReason {
      TemporaryProblem = 1,
      GeneralError = 2,
      MinBetThresholdNotReached = 3,
      BetWasFundedFromBonusOnly = 4,
      InsufficientFunds = 5,
      DailyWagerLimitReached = 6,
      DailyLossLimitReached = 7,
      WeeklyWagerLimitReached = 8,
      WeeklyLossLimitReached = 9,
      NonPeriodicLossLimitReached = 10,
      MonthlyLossLimitReached = 11,
      MonthlyWagerLimitReached = 12,
      AmountExceededRegulationLimit = 13,
      MaxStakeReached = 14,
}

/**
 * !TODO
 * check confluence docs if is final
 * https://evokeplc.atlassian.net/wiki/spaces/PT/pages/957612551/How+to+test+-+JackpotBet+-+consume+JP+Bet+Win+message+and+send+Firebase+message
 * {    "Cid": 34321,
 *      "Timestamp": "2025-03-03",
 *      "WinAmount": 1500,
 *      "CurrencyCode": 840,
 *      "GameTypeId": 1,
 *      "JackpotId":5001,
 *      "GameCycleId": 78901,
 *      "ParticipationFee": 25,
 *      "ParentGameBetAmount": 500
 * }
 * 
 * 
 * !TODO 
 * Error:
 * {
 *      "Cid": 34321,
 *      "Timestamp": "2025-03-03", 
 *      "ServerId":1, 
 *      "ParentGameTypeId": 1000,
 *      "RegulationTypeId": 840,
 *      "GameId": 1,
 *      "BrandId":5001,
 *      "PlayerSessionId": 78901,
 *      "SubBrandId": 50,
 *      "ProductPackage": 500, 
 *      "GameBetAmount": 500, 
 *      "ValueOfFailedBet":1, 
 *      "FailedReasonId":1, 
 *      "FailedReasonDescription":"", 
 *      "GameTypeId":1
 * }
 */